import * as actionTypes from "./orderActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
const { REACT_APP_API_URL } = process.env;

export const createOrder = (data) => {
    return (dispatch) => {
        dispatch(createOrderInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/order/store`, data))
        .then((response) => {
            dispatch(createOrderSuccess(response.data));
        })
        .catch(function (error) {
            dispatch(createOrderFailure());
            checkError(error);
        })
    };
};

export const createOrderInit = () => ({
    type: actionTypes.CREATE_ORDER
});

export const createOrderFailure = () => ({
    type: actionTypes.CREATE_ORDER_FAILURE
});

export const createOrderSuccess = data => ({
    type: actionTypes.CREATE_ORDER_SUCCESS,
    payload: { data }
});

export const createOrderCOD = (data) => {
    return (dispatch) => {
        dispatch(createOrderCODInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/order/store-cod`, data))
        .then((response) => {
            dispatch(createOrderCODSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(createOrderCODFailure());
            checkError(error);
        })
    };
};

export const createOrderCODInit = () => ({
    type: actionTypes.CREATE_ORDER_COD
});

export const createOrderCODFailure = () => ({
    type: actionTypes.CREATE_ORDER_COD_FAILURE
});

export const createOrderCODSuccess = data => ({
    type: actionTypes.CREATE_ORDER_COD_SUCCESS,
    payload: { data }
});

export const confirmOrder = (data) => {
    return (dispatch) => {
        dispatch(confirmOrderInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/order/confirm-payment`, data))
        .then((response) => {
            dispatch(confirmOrderSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(confirmOrderFailure());
            checkError(error);
        })
    };
};

export const confirmOrderInit = () => ({
    type: actionTypes.CONFIRM_ORDER
});

export const confirmOrderFailure = () => ({
    type: actionTypes.CONFIRM_ORDER_FAILURE
});

export const confirmOrderSuccess = data => ({
    type: actionTypes.CONFIRM_ORDER_SUCCESS,
    payload: { data }
});

export const applyCoupon = (data) => {
    return (dispatch) => {
        dispatch(applyCouponInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/coupon/apply-coupon`, data))
        .then((response) => {
            dispatch(applyCouponSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(applyCouponFailure());
            checkError(error);
        })
    };
};

export const applyCouponInit = () => ({
    type: actionTypes.APPLY_COUPON
});

export const applyCouponFailure = () => ({
    type: actionTypes.APPLY_COUPON_FAILURE
});

export const applyCouponSuccess = data => ({
    type: actionTypes.APPLY_COUPON_SUCCESS,
    payload: { data }
});

export const fetchOrder = (id) => {
    return (dispatch) => {
        dispatch(fetchOrderInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/order/${id}`))
        .then((response) => {
            dispatch(fetchOrderSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchOrderFailure());
            checkError(error);
        })
    };
};

export const fetchOrderInit = () => ({
    type: actionTypes.FETCH_ORDER
});

export const fetchOrderFailure = () => ({
    type: actionTypes.FETCH_ORDER_FAILURE
});

export const fetchOrderSuccess = data => ({
    type: actionTypes.FETCH_ORDER_SUCCESS,
    payload: { data }
});

export const fetchOrders = () => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem("userToken")}` } };
    return (dispatch) => {
        dispatch(fetchOrdersInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/order/customer`, config))
        .then((response) => {
            dispatch(fetchOrdersSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchOrdersFailure());
            checkError(error);
        })
    };
};

export const fetchOrdersInit = () => ({
    type: actionTypes.FETCH_ORDERS
});

export const fetchOrdersFailure = () => ({
    type: actionTypes.FETCH_ORDERS_FAILURE
});

export const fetchOrdersSuccess = data => ({
    type: actionTypes.FETCH_ORDERS_SUCCESS,
    payload: { data }
});

export const resetOrderState = () => ({
    type: actionTypes.RESET_ORDER_STATE
});